import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { SiteMapBody } from "../components/SiteMapBody";

export const Template = (
    props: Immutable<templates.SiteMapDocumentTemplate>,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <SiteMapBody entries={props.entries} />
    </PageSkeleton>
);
